import { Tenant, TenantCreateRequest, TenantUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { useState, useEffect } from "react";
import {
    Button,
    Input,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";

type AddEditTenantModalProps = {
    isOpen: boolean;
    tenant?: Tenant;
    handleAddTenant: (data: TenantCreateRequest) => Promise<void>;
    handleEditTenant: (tenantId: string, req: TenantUpdateRequest) => Promise<void>;
    onClose: () => void;
};

export const AddEditTenantModal = ({
    isOpen,
    tenant,
    handleAddTenant,
    handleEditTenant,
    onClose,
}: AddEditTenantModalProps) => {

    const [tenantName, setTenantName] = useState(tenant?.name ?? '');
    const [tenantEmail, setTenantEmail] = useState(tenant?.email ?? '');

    useEffect(() => {
        setTenantName(tenant?.name ?? '');
        setTenantEmail(tenant?.email ?? '');
    }, [tenant]);

    const handleSubmit = async () => {
        if (tenant && tenantName.trim() && tenantEmail.trim()) {
            await handleEditTenant(tenant.id, { name: tenantName.trim(), email: tenantEmail.trim() });
        } else if (tenantName.trim()) {
            await handleAddTenant({ name: tenantName.trim(), email: tenantEmail.trim() });
        }
        onCloseModal();
    };

    const onCloseModal = () => {
        setTenantName('');
        setTenantEmail('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onCloseModal}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{tenant ? 'Edit Tenant' : 'Add Tenant'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl isRequired>
                        <FormLabel htmlFor="tenantName">Tenant Name</FormLabel>
                        <Input
                            id="tenantName"
                            value={tenantName}
                            onChange={(e) => setTenantName(e.target.value)}
                            placeholder="Enter Tenant Name"
                        />
                    </FormControl>
                    <FormControl isRequired>
                        <FormLabel htmlFor="tenantEmail">Tenant Email</FormLabel>
                        <Input
                            id="tenantEmail"
                            value={tenantEmail}
                            onChange={(e) => setTenantEmail(e.target.value)}
                            placeholder="Enter Tenant Email"
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="outline" mr={3} onClick={onCloseModal}>
                        Close
                    </Button>
                    <Button
                        colorScheme="teal"
                        onClick={handleSubmit}
                        isDisabled={!tenantName.trim() || !tenantEmail.trim()}
                    >
                        {tenant ? 'Edit Tenant' : 'Add Tenant'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
